import React from 'react';
import styled from 'styled-components';



// 모달 버튼


export default function Madal_btn_inner({setShowModal,setModalOption , submitClick}){
    let handleCancel = () => {
        setShowModal(false);
        if(setModalOption)
        {
            setModalOption("");
        }

    };
    return (
        <Modal_button_inner>
            <Modal_btn 
                onClick={handleCancel} 
                style={{borderRight:"calc(100vw*(1/375)) solid #c6c6c6"}}>
            {"취소"}
            </Modal_btn>
            <Modal_btn 
                onClick={()=>{submitClick ? submitClick() : setShowModal(false)}} 
               >
            {"확인"}
            </Modal_btn>
        </Modal_button_inner>
    )
}




const Modal_button_inner = styled.div`
    width: 100%;
    height: calc(100vw*(44/375));
    border-top: calc(100vw*(1/375)) solid #c6c6c6;
`
const Modal_btn = styled.button`
    width:50%;
    height:100%;
    font-size: calc(100vw*(16/375));
    font-weight: bold;
    line-height: 1.38;
    text-align: center;
    color: #008aff;
`